module.exports = __webpack_public_path__ + "static/media/logo-prism.28b1324c.svg";